import RegisterShipment from './registerShipment';

export default RegisterShipment;
